/** The approved homepage lettering and botanical artwork—not the archived raster mask. */
import { BRAND_SPRIG_PATHS } from "./brand-artwork";

export function BrandWordmark(input: {
  className: string;
  typeClassName: string;
  sprigClassName: string;
  label?: string;
}) {
  return (
    <span
      className={input.className}
      {...(input.label ? { role: "img", "aria-label": input.label } : {})}
    >
      <span className={input.typeClassName} {...(input.label ? { "aria-hidden": true } : {})}>
        Life’s Capsule
      </span>
      <svg className={input.sprigClassName} viewBox="0 0 42 46" aria-hidden="true">
        {BRAND_SPRIG_PATHS.map((path) => (
          <path key={path} d={path} />
        ))}
      </svg>
    </span>
  );
}
